import { gql } from '@anyx/common-graphql';

export const CRM_META_TOKEN_STATUS = gql(/* GraphQL */ `
  fragment CrmMetaTokenStatus on MetaTokenStatus {
    ... on MTS_INVALID_TOKEN {
      __typename
    }
    ... on MTS_TOKEN_MISSING_SCOPE {
      scopes
    }
    ... on MTS_UNKNOWN {
      message
    }
    ... on MTS_WORKING {
      __typename
    }
  }
`);

export const CRM_STORE_DATA = gql(/* GraphQL */ `
  fragment CrmStoreData on AnyChatStore {
    id
    name
    isCrmEnabled
    crmType
    hasSlackNotifications
    draftReplyEnabled
    slackChannelId
    saleChannels {
      id
      type
    }
    chats {
      id
      type

      ... on LineStoreChat {
        messageQuota {
          consumption
          limit
        }
        isRefreshTokenSuccess
        isAIReplyEnable
      }

      ... on InstagramStoreChat {
        tokenStatusV2 {
          ...CrmMetaTokenStatus
        }
      }

      ... on MessengerStoreChat {
        tokenStatusV2 {
          ...CrmMetaTokenStatus
        }
      }

      ... on LazadaStoreChat {
        tokenUpdatedSuccessfully
      }

      ... on ShopeeStoreChat {
        isAIReplyEnable
        tokenUpdatedSuccessfully
      }

      ... on WhatsAppStoreChat {
        name
        optInEnabled
        isAIReplyEnable
      }
    }
  }
`);

export const VALIDATE_CRM_STORE = gql(/* GraphQL */ `
  query ValidateCrmStore($input: AnyChatGetStoreRequest!) {
    AnyChatStore(input: $input) {
      ...CrmStoreData
    }
  }
`);

